import { DataTable } from "../../../shared/components/data-table/DataTable";
import { Link } from "react-router-dom";
import { resolveRoleDetail } from "../../../shared/lib/routesResolver";

const RolesTable = ({ data }) => {
  const columns = [
    {
      accessorKey: "name",
      header: "Nombre",
      cell: ({ row }) => (
        <div className="font-bold underline">
          <Link to={resolveRoleDetail(row.original.id)}>
            {row.original.name}
          </Link>
        </div>
      ),
    },
    { accessorKey: "code", header: "Código" },
    { accessorKey: "description", header: "Descripción" },
  ];

  return <DataTable data={data} columns={columns} />;
};

export default RolesTable;
